var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"id":"iframe_visualization","src":_vm.vis_link,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }